import React from 'react';

// A raw code (ONE_ON_ONE_MEMBER, system:recalc:cms) as-is, with a line-break opportunity after each
// underscore and colon, so a narrow column breaks it between words, never one letter per line.
export const code_parts = (text) =>
  String(text === null || text === undefined ? '' : text).split(/(?<=[_:])/);

const CodeBreaks = ({ text }) =>
  code_parts(text).map((part, i) => (
    // eslint-disable-next-line react/no-array-index-key
    <React.Fragment key={i}>
      {i > 0 ? <wbr /> : null}
      {part}
    </React.Fragment>
  ));

export default CodeBreaks;
